/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import { groupBy } from 'lodash';
import * as React from 'react';

import {
  AttachMoney,
  MoneyOff,
  Repeat,
  Task,
} from '@mui/icons-material';
import {
  Badge,
  Box,
  Chip,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  getBillableValue,
  getChipForStatus,
} from '../../pages/billing/components/BillablesTable';
import { primary } from '../../utils/brandColors';
import Horse from '../Horse';
import { getAvatarGroupForUsers } from '../Planner/components/TaskCalendarOverview/components/TaskOverviewCell';

const customComparator = (prevProps, nextProps) => JSON.stringify(nextProps.billable) === JSON.stringify(prevProps.billable)
  && prevProps.billable.modifiedTimestamp === nextProps.billable.modifiedTimestamp && !prevProps.selectable;

const BillableItem = React.memo(({
  handleBillablePress = null,
  billable: item = null,
  containerProps = {},
  hideTitleDate = false,
  displayHorse = true,
  condensed = false,
}) => {
  const eventTemplates = useSelector((state) => state.eventTemplate.eventTemplates);
  const eventTemplatesMap = groupBy(eventTemplates, 'id');
  const color = (eventTemplatesMap[item.taskTypeId]
    && eventTemplatesMap[item.taskTypeId][0].eventDataDefaultValues
    && eventTemplatesMap[item.taskTypeId][0].eventDataDefaultValues.calendarDisplayColor) || primary[500];

  if (displayHorse && (!item || !item.horse)) return <Box />
  return (
    <Paper
      onClick={(e) => { if (handleBillablePress) { handleBillablePress(e, item); } }}
      {...containerProps}
      sx={[{
        p: 1,
        flex: 1,
      }, containerProps.sx || {}]}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexDirection: condensed
            ? 'column'
            : 'row',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flex: 1,
          }}
        >
          <Badge
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            badgeContent={item.repeatNextOccurrenceDate && (
              <Repeat
                color="secondary"
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                }}
              />
            )}
          >
            {eventTemplatesMap[item.repeatTaskTypeId || item.taskTypeId]
              ? (
                <Task
                  sx={{
                    color,
                    height: '2rem !important',
                    width: '2rem !important',
                  }}
                />
              )
              : (item.receivable
                ? (
                  <AttachMoney
                    sx={{
                      color,
                      height: '2rem !important',
                      width: '2rem !important',
                    }}
                  />
                )
                : (
                  <MoneyOff
                    sx={{
                      height: '2rem !important',
                      width: '2rem !important',
                    }}
                  />
                ))}
          </Badge>
          {
            !hideTitleDate && (
              <Box
                sx={!item.billableDate
                  ? {
                    flex: 1,
                    textWrap: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 0.5,
                  }
                  : {}}
              >
                {
                  item.note && (
                    <Typography
                      variant="h5"
                      sx={{
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                      }}
                    >
                      {(item.note && `${item.note}${item.quantity
                        ? ` (qty ${item.quantity})`
                        : ''}`) || '-'}
                    </Typography>
                  )
                }
                {
                  item.billableDate
                    ? (
                      <Typography
                        sx={{
                          flex: 1,
                          textWrap: 'auto',
                        }}
                        variant="caption"
                      >
                        {moment(item.billableDate).format('ddd MMM Do')}
                      </Typography>
                    )
                    : <Tooltip title="Transaction pending. Associated task must first be completed."><Chip size="small" label="Pending" color="warning" variant="outlined" /></Tooltip>
                }
                {
                  item.repeatNextOccurrenceDate
                  && (
                    <Typography
                      variant="caption"
                      component="div"
                    >
                      Next occurrence {moment(item.repeatNextOccurrenceDate).format('ll')}
                    </Typography>
                  )
                }
              </Box>
            )
          }
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              textWrap: 'auto',
              marginTop: 1,
              gap: 2,
            }}
          >
            {item.horse && displayHorse && <Horse horse={item.horse} />}
            {
              (!item.barnUsers || item.barnUsers.length === 0)
                ? <Box />
                : (
                  (getAvatarGroupForUsers(item.barnUsers, item.id))
                )
            }
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              justifyContent: 'space-between',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            <Typography
              fontWeight={700}
              sx={{
                color: item.receivable
                  ? (item.status === 'Open'
                    ? primary[500]
                    : '#2E7D2D')
                  : undefined,
              }}
            >
              {item.receivable
                ? '+'
                : '-'}${getBillableValue(item.price)}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              {
                item.billableDate && new Date(item.billableDate).getTime() > moment().endOf('day').toDate().getTime() && <Chip size="small" label="Upcoming" />
              }
              {
                item.repeatNextOccurrenceDate && !(new Date(item.billableDate).getTime() > moment().endOf('day').toDate().getTime()) && <Chip size="small" label="Repeating" />
              }
              {getChipForStatus(item)}
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}, customComparator);

export default BillableItem;
